export default function convertMetersToKilometers(value) {
  if (value >= 1000) {
    return `${parseFloat((value / 1000).toFixed(1))} km`;
  }

  return `${value} m`;
}
